import { interpolate, toText } from "../fable_modules/fable-library-js.4.24.0/String.js";

export function API_CrewCertificates_AllCertificates(includeDisabled) {
    return `${"/api/crew-certificate"}?disabled=${includeDisabled}`;
}

export function API_Vessel_vessel(x) {
    return `/api/vessel/${x}`;
}

export function API_Vessel_vesselEvents(x) {
    return toText(interpolate("/api/vessel/%d%P()/events", [x]));
}

export function API_Vessel_Audits(x) {
    return toText(interpolate("/api/audit-logs/vessel/%d%P()", [x]));
}

export function API_Vessel_Favorite(vesselId) {
    return `/api/vessel/favorite/${vesselId}`;
}

export function API_Route_Events(routeId) {
    return toText(interpolate("/api/route/%d%P()/events", [routeId]));
}

export function API_Route_Info(routeId) {
    return `/api/route/info/${routeId}`;
}

export function API_Route_Favorite(routeId) {
    return `/api/route/favorite/${routeId}`;
}

export function API_Route_Audits(x) {
    return toText(interpolate("/api/route/%d%P()/audits", [x]));
}

//# sourceMappingURL=Urls.js.map
